import ButtonGroupButton from '../../buttonGroup/ButtonGroupButton'
import ButtonGroup from '../../buttonGroup/ButtonGroup'
import { FormFieldButtonGroupProps } from '../_props'
import { generateRandomGuiID } from '../../../../../utils/commonUtils'

const FormFieldButtonGroup = <T extends object>({ buttons }: FormFieldButtonGroupProps<T>) => (
    <ButtonGroup>
        {buttons.map((button) => (
            <ButtonGroupButton key={generateRandomGuiID()} {...button} />
        ))}
    </ButtonGroup>
)

export default FormFieldButtonGroup
